<div class="eval-page" [formGroup]="form">
    <div class="header-row">
        <h1>Evaluationsbogen Biosicherheitsmanagementplan Schwein</h1>
        <button mat-stroked-button type="button" (click)="back()">Zur Übersicht</button>
    </div>

    <ng-container *ngTemplateOutlet="workflowActions"></ng-container>

    <div class="card vorgaenger-card" *ngIf="vorgaengerBsId">
        <div class="vorgaenger-head">
            <h2>Vorgänger-Biosicherheitsplan #{{ vorgaengerBsId }}</h2>
            <span class="hint">Zum Abgleich bei 3.2/3.3: Vorgänger-PDF ansehen (nur Lesen).</span>
        </div>
        <div class="workflow-actions">
            <button mat-stroked-button type="button" color="primary" (click)="showVorgaengerPdf()">
                <mat-icon>picture_as_pdf</mat-icon>
                Vorgänger-PDF anzeigen
            </button>
        </div>
    </div>

    <ng-container *kienePermission="[1255]">
        <div class="tierarzt-row">
            <kiene-autocomplete
                (elementSelected)="setTierarzt($event)"
                [disabled]="isReadOnly() || isSaving"
                [displayFields]="['vorname', 'nachname']"
                [genericApiUrl]="'tierarzt/read_autocomplete.php'"
                [kieneObject]="currentVet"
                [placeholder]="'Tierarzt'"
            ></kiene-autocomplete>
        </div>
    </ng-container>

    <section class="card">
        <h2>1. Angaben zum Betrieb</h2>
        <div class="grid-4">
            <mat-form-field appearance="outline">
                <mat-label>Evaluationsjahr</mat-label>
                <input matInput type="number" formControlName="evaluationsJahr" />
            </mat-form-field>
            <ng-container formGroupName="betrieb">
                <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>VVVO-Nr.</mat-label>
                    <input matInput formControlName="vvvo" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>TSK-Nr.</mat-label>
                    <input matInput formControlName="tskNummer" />
                </mat-form-field>
            </ng-container>
        </div>
    </section>

    <section class="card">
        <h2>2. Angaben zur aktuellen Biosicherheitsberatung</h2>
        <div class="grid-3" formGroupName="tierarzt">
            <mat-form-field appearance="outline">
                <mat-label>Tierarzt/Tierärztin Name</mat-label>
                <input matInput formControlName="name" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Praxis</mat-label>
                <input matInput formControlName="praxis" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Registriernummer(n) / VVVO Praxis</mat-label>
                <input matInput formControlName="registriernummern" />
            </mat-form-field>
        </div>
        <div class="grid-2" formGroupName="berater">
            <mat-form-field appearance="outline">
                <mat-label>Landwirtschaftlicher Berater/in Name</mat-label>
                <input matInput formControlName="name" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Registriernummer(n) Berater</mat-label>
                <input matInput formControlName="registriernummern" />
            </mat-form-field>
        </div>
    </section>

    <section class="card">
        <h2>3. Evaluation des Biosicherheitsmanagementplans</h2>
        <div class="date-row">
            <mat-form-field appearance="outline" class="date-field">
                <mat-label>3.1 Datum der Beratung</mat-label>
                <input matInput [matDatepicker]="datumBeratungPicker" formControlName="datumBeratung" />
                <mat-datepicker-toggle matSuffix [for]="datumBeratungPicker"></mat-datepicker-toggle>
                <mat-datepicker #datumBeratungPicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="question">
            <div class="q-label">
                3.2 Sind die Angaben im Biosicherheitsmanagementplan zu Abläufen und Lageskizze aktuell?
            </div>
            <mat-radio-group formControlName="ablaufeLageskizzeAktuell">
                <mat-radio-button [value]="true">Ja</mat-radio-button>
                <mat-radio-button [value]="false"
                    >Nein, Plan aktualisieren (z. B. mit geänderten / zusätzlichen Seiten)</mat-radio-button
                >
            </mat-radio-group>

            <div class="upload-card" *ngIf="form.get('ablaufeLageskizzeAktuell')?.value === false">
                <h4>Aktualisierte Seiten / Lageskizze hochladen</h4>
                <input #planUpdateUploader type="file" multiple hidden (change)="onPlanUpdateFilesSelected($event)" />
                <div class="upload-list" *ngIf="planUpdateUploads.length > 0">
                    <div class="upload-list-row" *ngFor="let entry of planUpdateUploads; let i = index">
                        <button type="button" class="upload-file-link" (click)="openPlanUpdateDoc(entry)">
                            <mat-icon>description</mat-icon>
                            <span>{{ entry.dateiname }}</span>
                        </button>
                        <button
                            *ngIf="!isReadOnly()"
                            mat-stroked-button
                            color="warn"
                            type="button"
                            (click)="removePlanUpdateDoc($event, i)"
                        >
                            <mat-icon>delete</mat-icon>
                            Löschen
                        </button>
                    </div>
                </div>
                <button
                    *ngIf="!isReadOnly()"
                    type="button"
                    class="upload-dropzone"
                    (click)="openPlanUpdateFilePicker(planUpdateUploader)"
                    (dragover)="onPlanUpdateDragOver($event)"
                    (drop)="onPlanUpdateDrop($event)"
                >
                    <mat-icon>upload_file</mat-icon>
                    <div class="upload-title">Dateien hier reinziehen oder klicken</div>
                    <div class="upload-subtitle">z. B. geänderte Seiten, Lageskizze, PDF, Fotos</div>
                </button>
            </div>
        </div>

        <div class="question">
            <div class="q-label">
                3.3 Die Handlungsempfehlungen aus der vorherigen Biosicherheitsberatung wurden vollständig
                umgesetzt?
            </div>
            <mat-radio-group formControlName="handlungsempfehlungenUmgesetzt">
                <mat-radio-button [value]="true">Ja</mat-radio-button>
                <mat-radio-button [value]="false"
                    >Nein, die weiterhin umzusetzenden Maßnahmen werden in 3.5 gelistet.</mat-radio-button
                >
            </mat-radio-group>
            <p class="hint">
                Die umgesetzten Maßnahmen sind im vorherigen Biosicherheitsmanagementplan/Evaluationsbogen als
                erledigt zu kennzeichnen.
            </p>
        </div>

        <div class="question">
            <div class="q-label">3.4 Gibt es zusätzliche/neue Handlungsempfehlungen?</div>
            <mat-radio-group formControlName="zusaetzlicheEmpfehlungen">
                <mat-radio-button [value]="false">Nein</mat-radio-button>
                <mat-radio-button [value]="true"
                    >Ja, die umzusetzenden Maßnahmen werden in 3.5 gelistet</mat-radio-button
                >
            </mat-radio-group>
        </div>
    </section>

    <section class="card" *ngIf="showHandlungsempfehlungen()">
        <div class="section-head">
            <h2>3.5 Handlungsempfehlungen</h2>
            <button mat-stroked-button type="button" (click)="addHandlungRow()" [disabled]="isReadOnly()">
                Zeile hinzufügen
            </button>
        </div>
        <div class="handlung-table" formArrayName="handlungsempfehlungen">
            <div class="handlung-row head">
                <span>Nr.</span>
                <span>Schwachstelle</span>
                <span>Handlungsempfehlung</span>
                <span>Erledigt am</span>
                <span>Unterlagen</span>
                <span></span>
            </div>
            <div
                class="handlung-row"
                *ngFor="let row of handlungsempfehlungen.controls; let i = index"
                [formGroupName]="i"
            >
                <mat-form-field appearance="outline">
                    <input matInput formControlName="nr" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="schwachstelle" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="handlungsempfehlung" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="date-cell">
                    <input matInput [matDatepicker]="erledigtPicker" formControlName="erledigtAm" />
                    <mat-datepicker-toggle matSuffix [for]="erledigtPicker"></mat-datepicker-toggle>
                    <mat-datepicker #erledigtPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="unterlagen" />
                </mat-form-field>
                <button
                    mat-icon-button
                    type="button"
                    (click)="removeHandlungRow(i)"
                    [disabled]="isReadOnly() || handlungsempfehlungen.length <= 1"
                >
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
    </section>

    <section class="card">
        <div class="grid-2" formGroupName="beratungszeit">
            <mat-form-field appearance="outline">
                <mat-label>Beratungszeit Tierarzt (Stunden)</mat-label>
                <input matInput formControlName="tierarztStunden" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Beratungszeit Fachberater (Stunden)</mat-label>
                <input matInput formControlName="beraterStunden" />
            </mat-form-field>
        </div>

        <mat-checkbox formControlName="beihilfeBeantragen"
            >Beihilfe der Nds. Tierseuchenkasse für Folgeberatung beantragen</mat-checkbox
        >
    </section>

    <ng-container *ngTemplateOutlet="workflowActions"></ng-container>

    <ng-template #workflowActions>
        <div class="workflow-row card">
            <div class="workflow-status">
                <strong>Status:</strong> {{ getStatusLabel() }}
                <span *ngIf="vorgaengerBsId"> · Vorgänger-BSP #{{ vorgaengerBsId }}</span>
                <span *ngIf="isSaving"> – wird gespeichert…</span>
                <span *ngIf="isLoading"> – wird geladen…</span>
            </div>
            <div class="workflow-actions">
                <kiene-sign-button
                    [disabled]="!ebId || isSaving || isReadOnly() || isAlreadySigned()"
                    [buttonText]="'Tierhalter unterschreiben'"
                    [kuid]="planKuid"
                    [tierarzt_id]="tierarztId"
                    [kunde_id]="kundeId"
                    (kuid)="persistKuid($event)"
                    (signDialogClosed)="onTierhalterSignDialogClosed()"
                ></kiene-sign-button>
                <kiene-sign-button
                    *ngIf="hasBerater()"
                    [disabled]="!ebId || isSaving || isReadOnly() || isBeraterAlreadySigned()"
                    [buttonText]="'Berater/in unterschreiben'"
                    [beraterMode]="true"
                    [kuid]="planBeraterKuid"
                    (kuid)="persistBeraterKuid($event)"
                    (signDialogClosed)="onBeraterSignDialogClosed()"
                ></kiene-sign-button>
                <button
                    *kienePermission="[11001]"
                    mat-raised-button
                    color="accent"
                    type="button"
                    (click)="abschliessen()"
                    [disabled]="!ebId || isSaving || isReadOnly()"
                >
                    Abschließen
                </button>
                <ng-container *kienePermission="[11003]">
                    <button
                        *ngIf="statusId === 232"
                        mat-stroked-button
                        type="button"
                        (click)="reopen()"
                        [disabled]="!ebId || isSaving"
                    >
                        Wieder öffnen
                    </button>
                </ng-container>
                <button mat-stroked-button type="button" (click)="showPdf()" [disabled]="!ebId || statusId === 231">
                    PDF
                </button>
                <button
                    *ngIf="vorgaengerBsId"
                    mat-stroked-button
                    type="button"
                    (click)="showVorgaengerPdf()"
                >
                    Vorgänger-PDF
                </button>
            </div>
        </div>
    </ng-template>
</div>
